// extracted by mini-css-extract-plugin
var _1 = "getMagneticWallItemLayout-module__animateUploadProgressBarWidth--dHSUZ";
var _2 = "getMagneticWallItemLayout-module__animatedBackground--auBIp";
var _3 = "4px";
var _4 = "-4px";
var _5 = "-13px";
var _6 = "34px";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "compactPopOverOffset", _4 as "contentOffsetCompact", _5 as "contentOffsetFull", _6 as "minCommentHeight" }
